import 'moment';
export const MILLISECONDS_IN_A_MINUTE = 60000;
export const MILLISECONDS_IN_A_DAY = 86400000;

export default function DateUtilService() {

    this.dateFallsWithinDaysPriorFromToday = dateFallsWithinDaysPriorFromToday;
    this.isDateBetween = isDateBetween;
    this.dateMinusDays = dateMinusDays;
    this.daysInRange = daysInRange;
    this.isValidMinDateRange = isValidMinDateRange;
    this.setDateFormatByLanguage = setDateFormatByLanguage;

    var millisecondsInOneDay = 86400000;
    this.greaterThanToday = greaterThanToday;
    this.daysInRange = daysInRange;

    function dateFallsWithinDaysPriorFromToday(numDays, dateToCheck) {
        var today = new moment();
        var startOfRange = dateMinusDays(numDays, today);

        return isDateBetween(moment(dateToCheck), moment(startOfRange), today);
    }

    function isDateBetween(isBetweenDate, startOfRange, endOfRange) {
        startOfRange.startOf('day');
        endOfRange.endOf('day');
        var inclusivity = '[]'; // inclusive
        return isBetweenDate.isBetween(startOfRange, endOfRange, null, inclusivity);
    }

    function daysInMilliseconds(numDays) {
        return numDays * MILLISECONDS_IN_A_DAY;
    }

    function dateMinusDays(numDays, date) {

        var milliseconds = daysInMilliseconds(numDays);
        return moment(moment(date) - milliseconds).toDate();
    }

    function greaterThanToday(date) {
        if (date) {
            date = new Date(date);
            return date.getTime() > new Date().getTime();
        } else {
            return false;
        }
    }

    function daysInRange(dateStart, dateEnd) {
        if (dateEnd && dateStart) {
            return (dateEnd - dateStart) / MILLISECONDS_IN_A_DAY;
        }
    }

    function isValidMinDateRange(fromDate, toDate, maxDays) {
        var from = new Date(fromDate);
        var to = new Date(toDate);
        var timeDiff = Math.abs(from.getTime() - to.getTime());
        var dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (dayDiff >= maxDays)
            return false;
        return true;
    };

    function setDateFormatByLanguage(lang) {
        if (lang === 'en')
            return 'MM/dd/yy';
        else if (lang === 'de')
            return 'dd-MM-yyyy';
        else if (lang === 'fr')
            return 'dd/MM/yyyy';
    }

}
